import React from "react";
import { Users, Briefcase, Target, Handshake } from "lucide-react";

const StatsSection: React.FC = () => {
  const features = [
    {
      icon: Users,
      title: "다양한 인재풀",
      description: "프론트엔드, 백엔드, DevOps, 모바일 등 다양한 분야의 우수한 인재들이 등록되어 있습니다",
    },
    {
      icon: Briefcase,
      title: "실시간 채용공고",
      description: "HR 담당자들이 직접 등록한 최신 채용공고를 실시간으로 확인할 수 있습니다",
    },
    {
      icon: Target,
      title: "정확한 매칭",
      description: "AI 기반 추천 시스템으로 회사와 인재의 요구사항을 정확히 매칭해드립니다",
    },
    {
      icon: Handshake,
      title: "직접 연결",
      description: "HR과 인재가 직접 소통하고 연결될 수 있는 플랫폼을 제공합니다",
    },
  ];

  return (
    <div className="py-16 bg-gradient-to-r from-blue-600 to-indigo-700">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            HR과 인재를 직접 연결하는 플랫폼
          </h2>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            최고의 인재와 최적의 기회를 만나게 해주는 스마트한 채용 플랫폼입니다
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full mb-4">
                <feature.icon className="w-8 h-8 text-white" />
              </div>
              <div className="text-lg font-semibold text-white mb-3">
                {feature.title}
              </div>
              <div className="text-sm text-blue-200 leading-relaxed">
                {feature.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatsSection;
